import React, { useCallback, useContext } from 'react';

import { TopTerritoriesItem } from './RadioSpinsTopTerritories';
import { EntityContext } from 'context/entityContext';

/**
 * TopUSMarket displays a single TopCities list item in the
 * RadioSpinsTopTerritories component.
 * @param {object} props React props
 * @param {object} props.item US Market item
 * @param {number} props.rank This markets' rank
 */

interface ITopUSMarketProps {
  item: any;
  entity: any;
  rank: number;
}

const TopUSMarket: React.FC<ITopUSMarketProps> = (props) => {
  const { item, entity, rank } = props;

  const ctx = useContext(EntityContext);
  const { entityIds, compareMode, dataColors } = ctx;

  const getColor = useCallback(() => {
    if (compareMode === 'entity') {
      const idx = entityIds.findIndex((el) => el === entity.id);
      return dataColors[idx];
    }
  }, [compareMode, dataColors, entity.id, entityIds]);

  return (
    <TopTerritoriesItem data-rank={rank} dataColor={getColor()}>
      {item.marketName}
    </TopTerritoriesItem>
  );
};

export default TopUSMarket;
